import React from 'react';
import ReactGA from 'react-ga';
import imgUrl from '../../assets/gie-logo-bg-3.jpg';
import GIEServicesContainer from "../../components/GIEServicesContainer/GIEServicesContainer";
import TitleListScreen from "../../components/TitleListeScreen/TitleListScreen";
import CardHome from "../Home/CardHome";
import enveloppeIcon from '../../assets/icon/envelope.svg';
import euroIcon from '../../assets/icon/circle-euro.svg';
import vanIcon from '../../assets/icon/van.svg';
import chauffeEauIcon from '../../assets/icon/chauffe-eau.svg';
import screwdriverWrenchIcon from '../../assets/icon/screwdriver-wrench.svg';
import GIESvgIcon from "../../components/GIEIcon/GIESvgIcon";
import WarningIcon from "@material-ui/icons/Warning";

export default class MyService extends React.Component<any, any> {
  componentDidMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  render() {
    return (
      <div className="content">
        <GIEServicesContainer imgUrl={imgUrl} title={<TitleListScreen miniTitle="Services en ligne"
                                                                      href="services"
                                                                      title="Quel est votre besoin ?"/>}>
          <div className="container-xl mb-5">
            <div className="row g-4">
              <div className="col-xs-12 col-lg-4">
                <CardHome firstTitle="Modifier mon offre"
                          secondTitle=" "
                          icon={<GIESvgIcon big icon={chauffeEauIcon}/>}
                          link="Accéder au service"
                          url="/admin/changer-mon-offre"/>
              </div>
              <div className="col-xs-12 col-lg-4">
                <CardHome firstTitle="Souscrire au prélèvement automatique"
                          secondTitle=" "
                          icon={<GIESvgIcon big icon={euroIcon}/>}
                          link="Accéder au service"
                          url="/admin/coordonnees-bancaires"/>
              </div>
              <div className="col-xs-12 col-lg-4">
                <CardHome firstTitle="Je déménage"
                          secondTitle=" "
                          icon={<GIESvgIcon big icon={vanIcon}/>}
                          link="Accéder au service"
                          target="_blank"
                          url="https://gie-sa.fr/services-en-ligne/je-demenage/"/>
              </div>
              <div className="col-xs-12 col-lg-4">
                <CardHome firstTitle="Installer ou remplacer un équipement"
                          secondTitle=" "
                          icon={<GIESvgIcon big icon={screwdriverWrenchIcon}/>}
                          link="Accéder au service"
                          url="/admin/equipement"/>
              </div>
              <div className="col-xs-12 col-lg-4">
                <CardHome firstTitle="Signaler une panne"
                          secondTitle=" "
                          icon={<WarningIcon className="big"/>}
                          link="Accéder au service"
                          url="/admin/formulaire-d-urgence"/>
              </div>
              <div className="col-xs-12 col-lg-4">
                <CardHome firstTitle="Autre demande"
                          secondTitle=" "
                          icon={<GIESvgIcon big icon={enveloppeIcon}/>}
                          link="Accéder au service"
                          target="_blank"
                          url="https://gie-sa.fr/contact/#"/>
              </div>
            </div>
          </div>
        </GIEServicesContainer>
      </div>
    );
  }
}
